import api from "./index";

// ========== 试剂使用监控 ==========

// 账户监控分页查询
export function fetchAccountMonitorPage(params) {
    return api.post("/web/reagent-monitor/account/page", params);
}

// 账户详情
export function getAccountDetail(params) {
    return api.get("/web/reagent-monitor/account/detail", { params });
}

// ========== 设备检测统计 ==========

// 设备监控分页查询
export function fetchDeviceMonitorPage(params) {
    return api.post("/web/reagent-monitor/device/page", params);
}

// 设备详情
export function getDeviceDetail(params) {
    return api.get("/web/reagent-monitor/device/detail", { params });
}

// ========== 异常预警中心 ==========

// 预警统计卡片
export function getWarningSummary() {
    return api.get("/web/reagent-monitor/warning/summary");
}

// 预警分页查询
export function fetchWarningPage(params) {
    return api.post("/web/reagent-monitor/warning/page", params);
}

// 预警详情
export function getWarningDetail(warningId) {
    return api.get(`/web/reagent-monitor/warning/detail/${warningId}`);
}

// 处理预警
export function handleWarning(data) {
    return api.post("/web/reagent-monitor/warning/handle", data);
}

// ========== 系统配置 ==========

// 试剂类型列表
export function fetchReagentTypeList() {
    return api.get("/web/reagent-monitor/reagent-type/list");
}

// 更新试剂类型
export function updateReagentType(data) {
    return api.post("/web/reagent-monitor/reagent-type/update", data);
}

// 预警规则列表
export function fetchRuleList() {
    return api.get("/web/reagent-monitor/rule/list");
}

// 更新预警规则
export function updateRule(data) {
    return api.post("/web/reagent-monitor/rule/update", data);
}

// ========== 统计计算 ==========

// 手动触发月度统计计算
export function calculateStat(statMonth) {
    return api.post("/web/reagent-monitor/stat/calculate", null, { params: { statMonth } });
}
